<template>
  <div class="login">
    <h1>Accident Plan Dangerzone</h1>
    <div class="pane">
      <h2>Login</h2>
      <UiTextbox floating-label label="Email" v-model="email" />
      <UiTextbox floating-label label="Password" type="password" v-model="password" />
      <p v-if="error" class="error">
        {{ error }}
      </p>
      <UiButton v-if="status === 'unauthenticated'" @click="submitLogin">Submit</UiButton>
      <UiButton v-if="status === 'pending'"><UiProgressCircular /></UiButton>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { UiButton, UiTextbox, UiProgressCircular } from 'keen-ui';

export default {
  name: 'Login',
  components: {
    UiButton,
    UiTextbox,
    UiProgressCircular,
  },
  hagridActions: ['Login/checkLogin'],
  async mounted() {
    await this.hagridPromise('Login/checkLogin');
    if (this.loggedIn) {
      this.$router.push({ name: 'Home' });
    }
  },
  data() {
    return {
      email: '',
      password: '',
    };
  },
  computed: {
    ...mapGetters({
      loggedIn: 'Login/loggedIn',
    }),
    ...mapState({
      error: state => state.Login.error,
      status: state => state.Login.status,
    }),
  },
  methods: {
    ...mapActions({
      logIn: 'Login/logIn',
    }),
    async submitLogin() {
      await this.logIn({ email: this.email, password: this.password });
      if (this.loggedIn) {
        this.$router.push({ name: 'Home' });
      }
    },
  },
};
</script>

<style lang="scss">
.login {
  .pane {
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    width: 400px;
    margin: 0 auto;
    padding: 2px 16px;
    h2 {
      text-align: center;
    }
    button {
      margin-bottom: 20px;
    }
  }
  .error {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue